module.exports = {"511028001":"古湖街道","511028002":"金鹅街道","511028101":"山川镇","511028102":"响石镇","511028103":"圣灯镇","511028104":"黄家镇","511028105":"双凤镇","511028106":"龙市镇","511028107":"迎祥镇","511028108":"界市镇","511028109":"石碾镇","511028110":"周兴镇","511028111":"渔箭镇","511028112":"石燕桥镇","511028113":"李市镇","511028114":"胡家镇","511028115":"云顶镇","511028116":"桂花井镇","511028117":"普润镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511028.json
// module id = 2457
// module chunks = 0